import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { selectIsPPConsented, selectIsTCConsented } from '@/store/selectors/consentsSelectors';
import { selectTagsLoaded } from '@/store/selectors/userSelectors';
import { MODALS } from '@/features/modal/types';
import { useModal } from '@/features/modal/useModal';

export function useConsents() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const tagsLoaded = useSelector(selectTagsLoaded);
  const isPPConsented = useSelector(selectIsPPConsented);
  const isTCConsented = useSelector(selectIsTCConsented);
  const { openModal } = useModal();

  useEffect(() => {
    if (!tagsLoaded) {
      return;
    }

    // Open the consent modal if the user have pending consents when logging in
    if (isAuthenticated && (isPPConsented === false || isTCConsented === false)) {
      openModal(MODALS.CONSENTS);
    }
  }, [isAuthenticated, tagsLoaded, isPPConsented, isTCConsented]);
}
